import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

import { NotificationPreferences } from './getPreferences';

type UpdatePreferencesRequest = {
  email?: Partial<NotificationPreferences['email']>;
  inApp?: Partial<NotificationPreferences['inApp']>;
};

type PreferencesResponse = {
  preferences: NotificationPreferences;
};

const updatePreferences = async (
  preferences: UpdatePreferencesRequest
): Promise<PreferencesResponse> => {
  const { data } = await customAxios.patch<PreferencesResponse>(
    '/notification-preferences',
    preferences
  );
  return data;
};

export const useUpdateNotificationPreferences = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePreferences,
    onSuccess: () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['notification-preferences'] }).catch(() => undefined);
    },
  });
};
